import axios from "axios";
import {
    IGarageList,
    IMotorcycle,
    IResponseMotorcycleList,
    IVehicleMaker,
    IVehicleModel,
    IVehicleType,
} from "../interfaces/Interfaces";

const API_BASE_URL = window.location.hostname === "localhost"
    ? "https://fyd.ge/v1/api"
    : "https://fyd.ge/v1/api";
export const fetchMakers = async (): Promise<IVehicleMaker[]> => {
    try {
        const response = await axios.get<IVehicleMaker[]>(`${API_BASE_URL}/Makers`);
        return response.data;
    } catch (error) {
        console.error("Error fetching makers:", error);
        throw error;
    }
};
export const fetchModels = async (makerId: number): Promise<IVehicleModel[]> => {
    try {
        const response = await axios.get<IVehicleModel[]>(`${API_BASE_URL}/Models/${makerId}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching models for maker ID ${makerId}:`, error);
        throw error;
    }
};
export const fetchTypes = async (): Promise<IVehicleType[]> => {
    try {
        const response = await axios.get<IVehicleType[]>(`${API_BASE_URL}/Models/types`);
        return response.data;
    } catch (error) {
        console.error("Error fetching types:", error);
        throw error;
    }
};
export const fetchMotorcycles = async (filters: {
    makerId: number | null;
    modelId: number | null;
    typeId: number | null;
}): Promise<IResponseMotorcycleList> => {
    try {
        const response = await axios.post<IResponseMotorcycleList>(`${API_BASE_URL}/Motorcycles/get-motorcycles`, filters);
        return response.data;
    } catch (error) {
        console.error("Error fetching motorcycles:", error);
        throw error;
    }
};
export const fetchMotorcycleById = async (id: number): Promise<IMotorcycle> => {
    try {
        const response = await axios.get<IMotorcycle>(`${API_BASE_URL}/Motorcycles/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching motorcycle by ID:", error);
        throw error;
    }
};
export const fetchMotorcyclesByIds = async (ids: string): Promise<IMotorcycle[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Motorcycles/${ids}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching motorcycles by IDs:", error);
        throw error;
    }
};
export const fetchFavouritesList = async (userId: number, session: string): Promise<IMotorcycle[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/Motorcycles/fav`, {
            headers: {
                "user-id": userId.toString(),
                session: session,
            },
            params: {
                userId: userId,
            },
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching favourites list:", error);
        throw error;
    }
};

export const addToFavourites = async (motorcycleId: number, userId: number, session: string): Promise<void> => {
    try {
        await axios.post(
            `${API_BASE_URL}/User/add-motorcycle-in-fav/${motorcycleId}`,
            {},
            {
                headers: {
                    "user-id": userId.toString(),
                    session: session,
                },
            },
        );
    } catch (error) {
        console.error("Error adding motorcycle to favourites:", error);
        throw error;
    }
};

export const removeFromFavourites = async (motorcycleId: number, userId: number, session: string): Promise<void> => {
    try {
        await axios.post(`${API_BASE_URL}/User/remove-motorcycle-from-fav/${motorcycleId}`,
            {},
            {
                headers: {
                    session: session,
                    "user-id": userId.toString(),
                },
            });
    } catch (error) {
        console.error("Error removing motorcycle from favourites:", error);
        throw error;
    }
};

export const fbLogin = async (
    session: string,
): Promise<IResponseMotorcycleList> => {
    try {
        const response = await axios.get<IResponseMotorcycleList>(`${API_BASE_URL}/user/login/${session}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching motorcycles:", error);
        throw error;
    }
};

export const fetchGarageList = async (): Promise<IGarageList[]> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/MotoService/get-moto-services`);
        return response.data;
    } catch (error) {
        console.error("Error fetching garage list:", error);
        throw error;
    }
};

export const fetchGarageListDetails = async (id: number): Promise<IGarageList> => {
    try {
        const response = await axios.get(`${API_BASE_URL}/MotoService/get-moto-service/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching garage list details:", error);
        throw error;
    }
};
